import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../../core/auth/auth.service";
import * as _ from 'lodash';

@Injectable()
export class PortalGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log('PortalGuard:canActivate:route', route);
    console.log('PortalGuard:canActivate:state', state);
    if (this.isScopeForThisSite()) {
      return true;
    } else {
      this.router.navigate(['/login']);
    }
    return false;
  }

  private isScopeForThisSite() {
    return _.indexOf(this.authService.decodedJwtToken.scope, "LOTTO_ADMIN_PORTAL") > -1;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/common/portal-guard.ts